import axios from 'axios';

export const updateAll = (context) => {
    return context.dispatch('updateBundle', 'dashboard');
};

export const updateBundle = (context, bundle) => {
    let url = `/${bundle}/counters`;

    if (bundle === 'fysioroadmap' && context.rootState.routePatientId) {
        url = `/fysioroadmap/${context.rootState.routePatientId}/counters`;
    }

    return axios.get(url)
        .then(response => {
            context.commit('updateBundle', { bundle, counters: response.data });
        })
        .catch(() => {
            // TODO: Do something with the error.
        });
};
